import Subscription24X7Panel from "./panels/Subscription24X7Panel";


const tabRoutes = [
  {
    name: "Subscription 24X7",
    path: "/member24x7-subscriptions",
    component: <Subscription24X7Panel />
  }
  // ,{
  //   name: "Member Home",
  //   path: "/member-home",
  //   component: <h1>Member Home Tab</h1>,
  // },
  // {
  //   name: "Family Members",
  //   path: "/family-members",
  //   component: <h1>Family Members Tab</h1>,
  // },
  // {
  //   name: "LifeStyle Membership",
  //   path: "/lifeStyle-membership",
  //   component: <h1>LifeStyle Membership Tab</h1>,
  // },
  // {
  //   name: "LifeStyle Activities",
  //   path: "/lifeStyle-activities",
  //   component: <h1>LifeStyle Activities Tab</h1>,
  // }
];

export default tabRoutes;

